import axios from "axios";

const { REACT_APP_SERVER_URL: SERVER_URL } = process.env;
const BASE_URL = `${SERVER_URL}/spin-the-wheel`;

// "/"
// "/validate"
// "/history"

async function getSpinTheWheel(token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(`${BASE_URL}/`);
    return data;
  } catch (e) {
    throw e;
  }
}

async function submitRewardCode(token, code) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.post(`${BASE_URL}/validate`, { code });
    return data;
  } catch (e) {
    throw e;
  }
}

async function submitOrderLocation(token, orderData) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.post(`${BASE_URL}/order`, orderData);
    return data;
  } catch (e) {
    throw e;
  }
}

async function redeemReward(token, orderId) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.post(`${BASE_URL}/redeem/${orderId}`);
    return data;
  } catch (e) {
    throw e;
  }
}

export default {
  getSpinTheWheel,
  submitRewardCode,
  submitOrderLocation,
  redeemReward,
};
